module.exports = __webpack_public_path__ + "img/zixun.7b952554.jpg";